export const course = {
    "course_title_Courses": "课时",
    "course_title_my_a_tutors": "我的课时管理",
    "course_title_Manager": "管理",
    "course_table_col_Grade": "年级",
    "course_table_col_Term": "学期",
    "course_table_col_Name": "名字",
    "course_table_col_Location": "地点",
    "course_table_col_Subject": "科目",
    "course_table_col_WeekDay": "星期",
    "course_table_col_Time": "时间",
    "course_table_col_Option": "选项",
    "course_table_col_Option_tip": "此设置用于确认是否生效，但已标记为可用的导师无法删除",
    "course_table_col_Enable": "启用",
    "course_table_col_Enable_tip": "此设置用于确认是否生效，但已标记为可用的导师无法修改",
    "course_Create_Course": "添加可用课时",
    "course_create_modal_title_edit": "修改课时",
    "course_create_modal_title_create": "添加课时",
    "course_create_modal_col_location": "校区",
    "course_create_modal_col_Location_tip": "请选择一个校区",
    "course_create_modal_col_WeekDay": "星期",
    "course_create_modal_col_WeekDay_tip": "请选择一个星期",
    "course_create_modal_col_Subject": "科目",
    "course_create_modal_col_Subject_tip": "请选择一个科目",
    "course_create_modal_col_Grade": "年级",
    "course_create_modal_col_Grade_tip": "请选择一个年级",
    "course_create_modal_col_Term": "学期",
    "course_create_modal_col_Term_tip": "请选择一个学期",
    "course_create_modal_col_TimePeriod": "时间段",
    "course_create_modal_col_Time_tip": "点击选择您要排除的时间段",
    "course_manager_tab_search": "查询可用Tutors",
    "course_manager_tab_marked": "已绑定课时",
    "course_manager_details_tip_alert": "您可以点击某一行，查看详细的可用时间段。",
};
